class PaginationComponent extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.itemsPerPage = 3;
    this.resultsLength = null;
    this.prevButtonAvailable = null;
    this.prevButtonUnavailable = null;
    this.nextButtonAvailable = null;
    this.nextButtonUnavailable = null;
    this.blocks = null;

    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.showPage = this.showPage.bind(this);
    this.updatePaginationDisplay = this.updatePaginationDisplay.bind(this);
  }

  connectedCallback() {
    this.resultsLength = parseInt(this.getAttribute('data-results-length'), 10) || 0;
    this.blocks = this.querySelectorAll('.event-card');

    // Get the different button variations
    this.prevButtonAvailable = this.querySelector('.prev-button.available');
    this.prevButtonUnavailable = this.querySelector('.prev-button.unavailable');
    this.nextButtonAvailable = this.querySelector('.next-button.available');
    this.nextButtonUnavailable = this.querySelector('.next-button.unavailable');

    // Add event listeners
    this.nextButtonAvailable.addEventListener('click', this.nextPage);
    this.prevButtonAvailable.addEventListener('click', this.prevPage);

    this.showPage(this.currentPage);
    this.updatePaginationDisplay();
  }

  showPage(page) {
    const blocks = this.querySelectorAll('.event-card');
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    let visibleCount = 0;

    blocks.forEach((block) => {
      const blockIndex = parseInt(block.getAttribute('data-index'), 10);

      if (blockIndex >= start + 1 && blockIndex <= end && visibleCount < this.itemsPerPage) {
        block.classList.remove('tw-hidden');
        block.classList.add('tw-flex');
        visibleCount++;
      } else {
        block.classList.add('tw-hidden');
        block.classList.remove('tw-flex');
      }
    });

    this.updatePaginationDisplay();
  }

  updatePaginationDisplay() {
    const totalPages = Math.ceil(this.resultsLength / this.itemsPerPage);

    const currentPageSpan = this.querySelector('.current-page');
    currentPageSpan.textContent = this.currentPage;

    const totalPagesSpan = this.querySelector('.total-pages');
    totalPagesSpan.textContent = totalPages;

    if (this.currentPage > 1) {
      this.prevButtonAvailable.classList.remove('tw-hidden');
      this.prevButtonUnavailable.classList.add('tw-hidden');
    } else {
      this.prevButtonAvailable.classList.add('tw-hidden');
      this.prevButtonUnavailable.classList.remove('tw-hidden');
    }

    if (this.currentPage < totalPages) {
      this.nextButtonAvailable.classList.remove('tw-hidden');
      this.nextButtonUnavailable.classList.add('tw-hidden');
    } else {
      this.nextButtonAvailable.classList.add('tw-hidden');
      this.nextButtonUnavailable.classList.remove('tw-hidden');
    }
  }

  nextPage() {
    if (this.currentPage * this.itemsPerPage < this.resultsLength) {
      this.currentPage++;
      this.showPage(this.currentPage);
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.showPage(this.currentPage);
    }
  }
}

customElements.define('pagination-component', PaginationComponent);
